import { Table, TableContainer, Thead, Tr, Th, Tbody, Td, Box, SkeletonText } from "@chakra-ui/react";

import ActiveStatus from "@/assets/ActiveStatus";
import InactiveStatus from "@/assets/InactiveStatus";
import EditIcon from "@/assets/EditIcon";
import DeleteIcon from "@/assets/DeleteIcon";
import OilIcon from "@/assets/OilIcon";
import GasIcon from "@/assets/GasIcon";
import ChemicalIcon from "@/assets/ChemicalIcon";
import Pagination from "../Layouts/Pagination";
import { COLORS } from "@/common/constants";
import countries from "@/data/countries";

const TableInspectorPerson = ({
    dataList,
    isLoading,
    handleEdit,
    handleDelete,
    currentPageSize,
    handleChangePageSize,
    handleChangePageNumber,
    currentPageNumber,
    totalPageNumber,
    hasNextPage
}: any) => {
    return (
        <TableContainer bgColor="#fff" borderRadius="13">
            <Box overflowX="auto">
                <Table variant='simple'>
                    <TableHeader />
                    <TableBody
                        isLoading={isLoading}
                        dataList={dataList}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                    />
                </Table>
            </Box>
            <Pagination
                currentPageSize={currentPageSize}
                currentPageNumber={currentPageNumber}
                totalPageNumber={totalPageNumber}
                handleChangePageSize={handleChangePageSize}
                handleChangePageNumber={handleChangePageNumber}
                hasNextPage={hasNextPage}
            />
        </TableContainer>
    );
};

const TableHeader = () => (
    <Thead>
        <Tr>
            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Name</Th>
            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14}>Category</Th>
            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Country</Th>
            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Type</Th>
            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Status</Th>
            <Th color={COLORS.TABLE_HEADER.FOREGROUND} backgroundColor={COLORS.TABLE_HEADER.BACKGROUND} textTransform="none" fontSize={14} textAlign='center'>Action</Th>
        </Tr>
    </Thead>
);

const TableBody = ({ isLoading, dataList, handleEdit, handleDelete }: any) => {
    if (isLoading) {
        return (
            <Tbody>
                <Tr key="loading">
                    <Td colSpan={5}>
                        <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='3' />
                    </Td>
                </Tr>
            </Tbody>
        );
    }

    if (!dataList || dataList.length === 0) {
        return (
            <Tbody>
                <Tr key="no-data">
                    <Td colSpan={5} textAlign="center">Data not found</Td>
                </Tr>
            </Tbody>
        );
    }

    return (
        <Tbody>
            {dataList.map((item: any, index: number) => (
                <InspectorRow
                    key={index}
                    item={item}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                />
            ))}
        </Tbody>
    );
};

const InspectorRow = ({ item, handleEdit, handleDelete }: any) => (
    <Tr>
        <Td>{item.fullName}</Td>
        <Td>
            <div style={{ display: 'flex', gap: 4 }}>
                {item.oil && <OilIcon />}
                {item.gas && <GasIcon />}
                {item.chemicals && <ChemicalIcon />}
            </div>
        </Td>
        <Td textAlign='center'>{countries.find((x) => x.value === item.country)?.label || item.country || '-'}</Td>
        <Td textAlign='center'>{item.type || '-'}</Td>
        <Td>
            <StatusIndicator status={item.status} />
        </Td>
        <Td style={{ display: 'flex', cursor: 'pointer', gap: 8, justifyContent: 'center', padding: '22px 0' }}>
            <EditIcon onClick={() => handleEdit(item.id)} />
            <DeleteIcon onClick={() => handleDelete(item.id)} />
        </Td>
    </Tr>
);

const StatusIndicator = ({ status }: { status: boolean }) => (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
        {status ? <ActiveStatus /> : <InactiveStatus />}
    </div>
);

export default TableInspectorPerson;
